module.exports = __webpack_public_path__ + "img/uy.9860a437.svg";